
import React, { useState } from 'react'

export const QuincesNameCmp = ({ addQuinceName }) => {
  const [quincename, setQuinceName] = useState('')
  function onChangeInput(event) {
    setQuinceName(event.target.value)
  }

  function handlerContinuar(quincename) {
    addQuinceName(quincename)
  }


  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handlerContinuar(event.target.value);
    }
  };


  return (
    <div style={{ marginTop: '-60%'}}>
      <h1 className="text-2xl font-bold mb-8">Cual es el nombre de la quinceañera?</h1>
      <div className="flex flex-col items-center">
        
          <input type="text" className="input input-bordered input-lg w-full max-w-xs" placeholder="Escribe aquí tu respuesta..." value={quincename} onChange={onChangeInput} onKeyDown={handleKeyPress}/>
        
        <button disabled={quincename ? false : true} className="btn btn-primary mt-5" onClick={()=>handlerContinuar(quincename)}>Continuar</button>
      </div>
    </div>
  )
}